import {jQuery as $, lodash as _} from 'lib/shim';

import {waitForRepaint} from 'util/dom';



const NAME = 'molecule-in-page-navigation',
	SELECTOR = '.'+NAME;



class MoleculeInPageNavigation {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$scrollBarHolder = this._$element.find('.links-wrapper').first();
			this._$scrollBar = this._$scrollBarHolder.find('.scrollbar').first();
			this._$scrollBarItems = this._$scrollBar.find('.scrollbar-link');
			this._$navigationBar = this._$element.find('.navigation-bar').first();
			// this._currentScrollIndex = ( this._$scrollBarItems.filter('.active').index() > 0) ? this._$scrollBarItems.filter('.active').index() : 0;
			this._currentScrollIndex = 0;
			this._stepValue = 0;
			this._maxScrollValue = 0;
			// -1 because the first item has the index 0
			this._maxItems = this._$scrollBarItems.length - 1;

			this._prime();
		}

		return $element;
	}



	_prime() {
		let _this_ = this,
			$scrollBar = this._$scrollBar,
			$scrollBarHolder = this._$scrollBarHolder,
			visibleArea = 0,
			maxScrollValue = this._maxScrollValue;

		this._app.registerWaitForWebFontsCallback('initInPageNavigation', () => {
			visibleArea = $scrollBarHolder.outerWidth();

			this._$scrollBarItems.each(function () {
				maxScrollValue += $(this).outerWidth(true);
			});
			maxScrollValue = visibleArea - maxScrollValue;

			this._showNavigationElements();
			this._calculateNextScrollBarPosition();
			this._setScrollBarValue();
		});

		_this_._$navigationBar.find('.arrow').each(function () {
			$(this).on('click', function () {
				visibleArea = $scrollBarHolder.outerWidth();
				maxScrollValue = visibleArea - $scrollBar.innerWidth();

				if ($(this).hasClass('arrow-left')) {
					_this_._moveLeft(_this_, maxScrollValue);
				} else {
					_this_._moveRight(_this_, maxScrollValue);
				}
			});
		});

		this._$scrollBar.bindSwipeGesture('left', (e) => {
			e.stopPropagation();

			visibleArea = $scrollBarHolder.outerWidth();
			maxScrollValue = visibleArea - $scrollBar.innerWidth();

			this._moveRight(_this_, maxScrollValue);
		}, 'scrollbarSwipeGesture', 0.05, false);

		this._$scrollBar.bindSwipeGesture('right', (e) => {
			e.stopPropagation();

			visibleArea = $scrollBarHolder.outerWidth();
			maxScrollValue = visibleArea - $scrollBar.innerWidth();

			this._moveLeft(_this_, maxScrollValue);
		}, 'scrollbarSwipeGesture', 0.05, false);

		this._app.registerResizeCallback(NAME+'-resize-'+this._id, () => {
			waitForRepaint(() => {
				this._showNavigationElements();
				if (!this._$navigationBar.hasClass('hidden')) {
					this._setScrollBarValue();
				}
			});
		});

		this._showNavigationElements();


		this._$element.on('move-right', (e) => {
			visibleArea = $scrollBarHolder.outerWidth();
			maxScrollValue = visibleArea - $scrollBar.innerWidth();

			this._moveRight(_this_, maxScrollValue);
		});


		this._$element.on('move-left', (e) => {
			visibleArea = $scrollBarHolder.outerWidth();
			maxScrollValue = visibleArea - $scrollBar.innerWidth();

			this._moveLeft(_this_, maxScrollValue);
		});
	}



	_showNavigationElements() {
		let scrollbarHolderWidth = this._$scrollBarHolder.outerWidth(),
			maxScrollbarItemsWidth = 0;

		this._$scrollBarItems.each(function () {
			maxScrollbarItemsWidth += $(this).outerWidth(true);
		});

		if (maxScrollbarItemsWidth > scrollbarHolderWidth) {
			this._$navigationBar.removeClass('hidden');
		} else {
			this._$navigationBar.addClass('hidden');
			this._$scrollBar.css('left', '0');
		}
	}



	_calculateNextScrollBarPosition(maxScrollValue=false) {
		if(maxScrollValue) {
			this._stepValue = maxScrollValue;
		} else {
			this._stepValue = 0;
			for (let i = 0; i < this._currentScrollIndex; i++) {
				this._stepValue -= this._$scrollBarItems.eq(i).outerWidth(true);
			}
		}
	}



	_setScrollBarValue() {
		this._$scrollBar.css('left', this._stepValue + 1);
	}



	_moveLeft(_this_, maxSrollValue) {
		if (_this_._currentScrollIndex > 0 ) {
			if (_this_._stepValue === maxSrollValue) {
				_this_._calculateNextScrollBarPosition();
				_this_._setScrollBarValue();
			} else {
				_this_._currentScrollIndex--;
				_this_._calculateNextScrollBarPosition();
				_this_._setScrollBarValue();
			}
		}
	}



	_moveRight(_this_, maxSrollValue) {
		if(_this_._currentScrollIndex < _this_._maxItems && !(_this_._stepValue <= maxSrollValue)) {
			_this_._currentScrollIndex++;
			_this_._calculateNextScrollBarPosition();

			if ((_this_._stepValue <= maxSrollValue) || (_this_._stepValue <= maxSrollValue)) {
				_this_._calculateNextScrollBarPosition(maxSrollValue);
			}
			_this_._setScrollBarValue();
			_this_._calculateNextScrollBarPosition();
		}
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new MoleculeInPageNavigation(app, $this));
	});

	return $elements;
}
